import { render, staticRenderFns } from "./graphical-email-templates-widget.vue?vue&type=template&id=252bb725&"
import script from "./graphical-email-templates-widget.vue?vue&type=script&lang=js&"
export * from "./graphical-email-templates-widget.vue?vue&type=script&lang=js&"
import style0 from "./graphical-email-templates-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports